import { MarketAsset } from "./market-asset";

export type CollateralAprAsset = typeof CollateralAprAsset.Type;
export type CollateralAprAssetEncoded = typeof CollateralAprAsset.Encoded;

export const CollateralAprAsset = MarketAsset.pick(
  "collateralBaseApr",
  "collateralRewardsApr",
  "collateralMerklRewards"
).annotations({ identifier: "CollateralAprAsset" });

export type ProtectedAprAsset = typeof ProtectedAprAsset.Type;
export type ProtectedAprAssetEncoded = typeof ProtectedAprAsset.Encoded;

export const ProtectedAprAsset = MarketAsset.pick(
  "protectedRewardsApr",
  "protectedMerklRewards"
).annotations({ identifier: "ProtectedAprAsset" });

export type DebtAprAsset = typeof DebtAprAsset.Type;
export type DebtAprAssetEncoded = typeof DebtAprAsset.Encoded;

export const DebtAprAsset = MarketAsset.pick(
  "debtBaseApr",
  "debtRewardsApr",
  "debtMerklRewards",
  "isDebtAprFixed",
  "depositMode"
).annotations({ identifier: "DebtAprAsset" });
